import { useMutation, useQueryClient } from '@tanstack/react-query';

import { API_QUERY_KEYS } from 'consts';

import { patchBoardUser } from '../requests';

export const usePatchBoardUser = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: patchBoardUser,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [API_QUERY_KEYS.boardUsers],
      });
    },
  });
};
